import React from 'react';

function TermsOfService() {
  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: [
        'By accessing and using Time2Find\'s services, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by these Terms of Service, please do not use our services.',
        'We reserve the right to update and change these Terms of Service at any time without notice. Continued use of the service after any such changes constitutes your consent to such changes.'
      ]
    },
    {
      title: '2. Description of Service',
      content: [
        'Time2Find provides enterprise IT consulting, cloud solutions, cybersecurity services, SAP implementation, data analytics, quality assurance, and IoT solutions (collectively, the "Services").',
        'We reserve the right to modify, suspend, or discontinue any part of the Services at any time with or without notice. We will not be liable to you or any third party for any modification, suspension, or discontinuance of the Services.'
      ]
    },
    {
      title: '3. Account Registration and Security',
      content: [
        'You may be required to register for an account to access certain Services. You agree to provide accurate, current, and complete information during registration and to update such information to keep it accurate, current, and complete.',
        'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to immediately notify us of any unauthorized use of your account.',
        'We reserve the right to suspend or terminate your account if any information provided is inaccurate, fraudulent, or violates these Terms of Service.'
      ]
    },
    {
      title: '4. Acceptable Use Policy',
      content: [
        'You agree to use the Services only for lawful purposes and in accordance with these Terms. You agree not to use the Services in any way that violates any applicable federal, state, local, or international law or regulation.',
        'You may not use the Services to transmit any material that is defamatory, offensive, or otherwise objectionable, or to engage in any conduct that restricts or inhibits anyone\'s use or enjoyment of the Services.',
        'You may not attempt to gain unauthorized access to any portion of the Services, other accounts, computer systems, or networks connected to the Services through hacking, password mining, or any other means.'
      ]
    },
    {
      title: '5. Intellectual Property Rights',
      content: [
        'The Services and all content, features, and functionality are owned by Time2Find and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.',
        'You may not reproduce, distribute, modify, create derivative works of, publicly display, republish, download, store, or transmit any of the material on our Services without our prior written consent.',
        'Any feedback, comments, or suggestions you provide regarding the Services may be used by Time2Find without any obligation to you.'
      ]
    },
    {
      title: '6. Professional Services and Deliverables',
      content: [
        'When you engage Time2Find for professional services, the specific scope of work, deliverables, timelines, and fees will be outlined in a separate Statement of Work (SOW) or service agreement.',
        'We will use reasonable efforts to meet agreed-upon timelines, but dates are estimates only. We are not liable for delays caused by circumstances beyond our reasonable control.',
        'All deliverables and work product created specifically for you under a paid engagement will be owned by you upon full payment, unless otherwise specified in the SOW.'
      ]
    },
    {
      title: '7. Payment Terms',
      content: [
        'Fees for Services will be specified in your service agreement or SOW. All fees are exclusive of applicable taxes unless otherwise stated. You are responsible for paying all applicable taxes.',
        'Payment is due within 30 days of the invoice date unless otherwise specified. Late payments may be subject to interest charges of 1.5% per month or the maximum rate permitted by law, whichever is less.',
        'We reserve the right to suspend Services if payment is not received within 60 days of the due date. Suspended Services will be reinstated upon receipt of all outstanding payments.'
      ]
    },
    {
      title: '8. Confidentiality',
      content: [
        'Both parties agree to maintain the confidentiality of any proprietary or confidential information disclosed during the course of the Services. This obligation survives the termination of the agreement.',
        'Confidential information does not include information that is publicly available, independently developed, or rightfully obtained from third parties without confidentiality obligations.',
        'You authorize us to use your company name and logo in our marketing materials and client lists unless you explicitly opt-out in writing.'
      ]
    },
    {
      title: '9. Warranties and Disclaimers',
      content: [
        'We warrant that we will perform the Services in a professional and workmanlike manner consistent with industry standards. This warranty is valid for 30 days from delivery of the Services.',
        'EXCEPT AS EXPRESSLY PROVIDED, THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.',
        'We do not warrant that the Services will be uninterrupted, error-free, or completely secure, or that defects will be corrected.'
      ]
    },
    {
      title: '10. Limitation of Liability',
      content: [
        'TO THE MAXIMUM EXTENT PERMITTED BY LAW, TIME2FIND SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY.',
        'Our total liability for any claims arising out of or related to the Services shall not exceed the amount paid by you to Time2Find in the 12 months preceding the claim.',
        'Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, so the above limitations may not apply to you.'
      ]
    },
    {
      title: '11. Indemnification',
      content: [
        'You agree to indemnify, defend, and hold harmless Time2Find and its officers, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses arising out of or related to your use of the Services or violation of these Terms.',
        'We reserve the right to assume exclusive defense and control of any matter subject to indemnification by you, and you agree to cooperate with our defense of such claims.'
      ]
    },
    {
      title: '12. Termination',
      content: [
        'Either party may terminate the Services upon written notice if the other party materially breaches these Terms and fails to cure such breach within 30 days of written notice.',
        'We may immediately suspend or terminate your access to the Services if we believe you have violated these Terms, engaged in fraudulent activity, or if required by law.',
        'Upon termination, you must immediately cease use of the Services, and any outstanding fees become immediately due and payable. Provisions that by their nature should survive termination shall survive.'
      ]
    },
    {
      title: '13. Governing Law and Dispute Resolution',
      content: [
        'These Terms shall be governed by and construed in accordance with the laws of the State of New York, United States, without regard to its conflict of law provisions.',
        'Any dispute arising out of or relating to these Terms shall first be attempted to be resolved through good faith negotiations. If negotiations fail, disputes shall be resolved through binding arbitration in New York, NY.',
        'You agree to waive any right to a jury trial or to participate in a class action lawsuit or class-wide arbitration.'
      ]
    },
    {
      title: '14. General Provisions',
      content: [
        'These Terms constitute the entire agreement between you and Time2Find regarding the Services and supersede all prior agreements and understandings.',
        'If any provision of these Terms is found to be unenforceable, the remaining provisions will continue in full force and effect.',
        'Our failure to enforce any right or provision of these Terms will not be deemed a waiver of such right or provision.',
        'You may not assign or transfer these Terms without our prior written consent. We may assign these Terms without restriction.'
      ]
    },
    {
      title: '15. Contact Information',
      content: [
        'If you have any questions about these Terms of Service, please contact us at:',
        'Email: legal@time2find.com',
        'Phone: +1 (555) 123-4567',
        'Address: Time2Find Global Headquarters, New York, NY'
      ]
    }
  ];

  return (
    <div className="policy-page">
      {/* Hero Banner */}
      <section className="policy-hero-banner">
        <div className="policy-hero-content">
          <div className="policy-badge">
            <i className="fas fa-file-contract"></i>
            <span>Legal</span>
          </div>
          <h1 className="policy-hero-heading">Terms of Service</h1>
          <p className="policy-hero-subtext">
            Please read these terms carefully before using our services. By using Time2Find, you agree to be bound by these terms.
          </p>
          <div className="policy-meta">
            <span className="policy-meta-item">
              <i className="fas fa-calendar-alt"></i>
              Last Updated: January 11, 2026
            </span>
            <span className="policy-meta-item">
              <i className="fas fa-clock"></i>
              15 min read
            </span>
          </div>
        </div>
      </section>

      <div className="policy-container">
        {/* Introduction */}
        <div className="policy-intro">
          <p>
            Welcome to Time2Find. These Terms of Service ("Terms") govern your access to and use of our services, 
            including our website, applications, and any related services (collectively, the "Services").
          </p>
          <p>
            By accessing or using our Services, you agree to be bound by these Terms and our Privacy Policy. 
            If you do not agree to these Terms, you may not access or use the Services.
          </p>
        </div>

        {/* Sections */}
        <div className="policy-sections">
          {sections.map((section, index) => (
            <div key={index} className="policy-section">
              <h2 className="policy-section-title">{section.title}</h2>
              <div className="policy-section-content">
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex}>{paragraph}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Summary Box */}
        <div className="policy-summary-box">
          <div className="policy-summary-icon">
            <i className="fas fa-info-circle"></i>
          </div>
          <div className="policy-summary-content">
            <h3 className="policy-summary-title">Key Points</h3>
            <p className="policy-summary-text">
              By using Time2Find, you agree to use our services responsibly and in compliance with all applicable laws. 
              We provide professional IT services with reasonable care, but we cannot guarantee uninterrupted or error-free service. 
              Our liability is limited, and disputes are resolved through arbitration in New York. 
              For questions, contact legal@time2find.com.
            </p>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="policy-cta">
          <h3 className="policy-cta-title">Questions About These Terms?</h3>
          <p className="policy-cta-text">
            Our legal team is available to clarify any questions you may have about our Terms of Service.
          </p>
          <a href="/contact" className="policy-cta-button">
            <i className="fas fa-envelope"></i>
            Contact Legal Team
          </a>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
